import isServer from '@hydra/utils/isServer';

export function sendEvent (event, eventLabel = {}) {
  if (!isServer()) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event,
        eventLabel: {
          ...eventLabel,
          ...(window.dataLayer[0] && window.dataLayer[0].userPlanCode === 'duda' ? { context: 'duda' } : {})
        }
      });
    }
  }
}
